import Tooltip from '@components/Tooltip/Tooltip';
import { notificationContext } from '@context/notifications';
import { faLink } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatUrlType } from '@modules/formatters';
import { Box, Text } from '@ui-lib';
import { motion } from 'motion/react';
import { type MouseEvent, useContext } from 'react';
import type { CardUrlType } from 'types';

import styles from './UrlFields.module.scss';

export const URLPreview = ({ value, type }: { value: string; type: string }): JSX.Element => {
  const { notify } = useContext(notificationContext);

  const tooltipContent = `This is the URL we will send people to when they click your ${formatUrlType(
    type as CardUrlType,
  )} field`;

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      notify({
        id: 'clipboard-success',
        type: 'info',
        title: 'Copied to clipboard',
        size: 'small',
        timeout: 1500,
      });
    });
  };

  return (
    <Tooltip size="small" label={tooltipContent} aria-label="URL Preview message">
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.2 } }}
        exit={{ opacity: 0, transition: { duration: 0.2 } }}
        className={styles['url-preview-content-container']}
        onClick={handleClick}
        type="button"
      >
        <Box gap="xxsmall" display="flex" alignItems="center">
          <span className={styles['url-preview-icon']}>
            <FontAwesomeIcon icon={faLink} />
          </span>
          <Text size="small" tone="secondary">
            {value}
          </Text>
        </Box>
      </motion.button>
    </Tooltip>
  );
};
